export const CLASS_NAMES = {
  ideasTab: 'ideas-tab',
  columnCardVisible: 'column-card-visible',
  columnHeaderLabel: 'idea-column-header-label',
} as const;

export const TEST_IDS = {
  bagelAiTab: 'bagel-ai-ideas-tab',
  pageActionsButton: 'page-actions-button',
} as const;
